import React, { Component } from 'react'
import { Trans } from '@lingui/react'
import SVGInline from 'react-svg-inline'
import cn from 'classnames'
import Spacer from 'client/shared/blocks/spacer'
import CloseIcon from 'client/shared/icons/close.svg'
import ChevronIcon from 'client/bookmate/blocks/sorting/chevron.svg'
import './details.styl'

type State = {
  open: boolean
}

type Props = {
  element: { heading: string; content: string; components?: JSX.Element[] }
  namespace: string
  textAsString?: boolean
  mode?: string
}

export class Details extends Component<Props, State> {
  state = {
    open: false,
  }

  toggleDetailsState = (): void => {
    this.setState({ open: !this.state.open })
  }

  render(): JSX.Element {
    const {
      element,
      namespace,
      textAsString = false,
      mode = 'details_light',
    } = this.props

    return (
      <div
        className={cn('details', mode, {
          details__open: this.state.open,
          details__closed: !this.state.open,
        })}
      >
        <div className="summary" onClick={this.toggleDetailsState}>
          <span className="summary__heading">
            <Trans id={`${namespace}.${element.heading}`} />
          </span>
          <SVGInline
            svg={this.state.open ? CloseIcon : ChevronIcon}
            className={cn('summary_icon', {
              summary_icon_close: this.state.open,
              summary_icon_open: !this.state.open,
            })}
          />
        </div>
        {this.state.open && (
          <div>
            <Spacer />
            <span className="summary__content">
              {textAsString ? (
                <span dangerouslySetInnerHTML={{ __html: element.content }} />
              ) : (
                <Trans
                  id={`${namespace}.${element.content}`}
                  components={element.components}
                />
              )}
            </span>
          </div>
        )}
      </div>
    )
  }
}
